import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { apiUrl, CHAT_METADATA_KEY, getRecaptchaToken, USE_QUERY_STALE_TIME } from 'utils';
import { AuthContext } from 'contexts';
import { ChatMetadata } from 'types';

export interface ChatMetadataParams {
  sessionID: string;
  chatId: string;
}

async function queryFn(params: ChatMetadataParams) {
  const result = await fetch(`${apiUrl}/web/${params.chatId}?sessionID=web:${params.sessionID}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + (await getRecaptchaToken()),
    },
  });
  return await result.json();
}

export function useChatMetadata(params: ChatMetadataParams) {
  const authContext = useContext(AuthContext);

  return useQuery<ChatMetadata>({
    queryKey: [CHAT_METADATA_KEY, params],
    queryFn: () => queryFn(params),
    staleTime: USE_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: authContext.isAuthenticated,
  });
}
